import { render } from "./BetslipCombinations.vue?vue&type=template&id=0d1024ef"
import script from "./BetslipCombinations.vue?vue&type=script&lang=js"
export * from "./BetslipCombinations.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__